import React from 'react';
import { PeekBox, PeekStack, PeekButton } from '@piiqtechnologies/ui-components';
import { StartWithRoomCtrl } from './StartWithRoomCtrl.js';
import { RoomName } from './RoomName.js';
import { HotspotDropBox } from './HotspotDropBox.js';
import CreateHotspotMenu from './hotspot-menu/CreateHotspotMenu.js';
import { CreateHotspotTool } from './hotspot-menu/CreateHotspotTool.js';
import { StartWithViewCtrl } from './StartWithViewCtrl.js';
import { UploadStagedImageCtrl } from './UploadStagedImageCtrl.js';

const EditingButtonMenu = ({ onDoneEditTour, createHotspotTool, toggleCreateHotspotTool, setPitchWarning, enableVirtualStaging, }) => {
    return (React.createElement(PeekBox, { sx: { position: "absolute", top: "0", left: "0", zIndex: 1 }, width: "100%" },
        React.createElement(HotspotDropBox, { setPitchWarning: setPitchWarning }),
        (!(createHotspotTool === null || createHotspotTool === void 0 ? void 0 : createHotspotTool.type) && (React.createElement(PeekStack, { sx: { p: 1.5 }, direction: "row", justifyContent: "space-between", spacing: 1 },
            React.createElement(PeekStack, { direction: "row", spacing: 1 },
                React.createElement(RoomName, null),
                React.createElement(CreateHotspotMenu, { onMenuItemSelection: toggleCreateHotspotTool }),
                React.createElement(StartWithRoomCtrl, null),
                React.createElement(StartWithViewCtrl, null),
                enableVirtualStaging && React.createElement(UploadStagedImageCtrl, null)),
            React.createElement(PeekBox, null,
                React.createElement(PeekButton, { onClick: onDoneEditTour, "area-label": "Done Editing", variant: "contained", sx: {
                        height: "auto",
                        minHeight: 28,
                    } }, "Done Editing"))))) || React.createElement(CreateHotspotTool, Object.assign({}, createHotspotTool, { toggleCreateHotspotTool: toggleCreateHotspotTool }))));
};

export { EditingButtonMenu, EditingButtonMenu as default };
